import { useSelector } from 'react-redux';
import { SharedStoreState } from '../types/store';
import { CurveManagerStoreState } from '../types/curveManager.types';

export const curveManagerSelector = (state: SharedStoreState) =>
	state.curveManager;

export const useSelectCurveManager = (): CurveManagerStoreState =>
	useSelector(curveManagerSelector);
